import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ProductCard from "components/cards/ProductCard";
import { asPrice } from "utils/text";
import { Link } from "react-router-dom";
import Images from 'assets/images/post_image.png'
import { asDate3 } from "utils/text";

export default ({ relatedEvents }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3} className={classes.products}>
      {relatedEvents.length > 0 ?  <Grid item xs={12}>
        <h3 align="left">
          More Events
        </h3>
      </Grid> : ''}
      {relatedEvents.map((event) => (
        <Grid item xs={12} md={3} lg={3} key={event.id}>
          <Card className={classes.root}>
            <div className={classes.contect}>
              <div className={classes.imageContainer}>
                <img
                  src={Images}
                  alt="event image"
                  className={classes.productImage}
                />
              </div>
              <div className={classes.eventDate}>
                <span className={classes.dateText}>
                  {asDate3(event.start_at)}
                </span>
              </div>
            </div>
          </Card>
          <Typography component="h2" variant="h6" className={classes.title}>
            {event.title}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  root:{borderRadius: '10px'},
  products: {
    marginTop: 50,
  },
  imageContainer: {
    height: 182,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  contect:{
    position:'relative',
  },
  productImage: {
    height:217,
    maxWidth: "100%",
  },
  dateText : {
    textAlign: 'center',
    display: 'block',
    marginTop: '10px',
    marginLeft: '5px',
    color: 'white',
    fontWeight: '700',
    fontSize: '14px'
  },
  eventDate:{
    display: 'inline-block !important',
    width: '103px',
    height: 0,
    boxSizing: 'content-box',
    borderLeft: 'calc(0px/2) solid transparent',
    borderRight: 'calc(35px/2) solid transparent',
    borderBottom: '35px solid #05C1FF',
    position: 'absolute',
    top: '147px',
    left: 0,
  },
  price: {
    marginTop: 6,
    marginBottom: 13,
    fontSize: 18,
    fontWeight: 500,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  memberPrice: {
    color: theme.palette.text.disabled,
    fontSize: 14,
  },
  Button: {
    fontSize: 14,
    fontWeight: 500,
    textTransform: "capitalize",
  },
}));
